import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { Empty } from "../components/common";
import { api, idr } from "../lib/api";
import { Avatar } from "../components/Avatar";

const months = () => Array.from({ length: 6 }, (_, i) => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - i); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; });

export const Leaderboard = () => {
  const [month, setMonth] = useState(months()[0]);
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let alive = true;
    setError(false);
    api.get("/affiliates/leaderboard", { params: { month } }).then((r) => alive && setData(r.data)).catch(() => alive && setError(true));
    return () => { alive = false; };
  }, [month]);
  const meOutside = data?.me && data.me.rank > 10;
  return (
    <section className="panel table-panel lb">
      <div className="panel-head">
        <div><p className="eyebrow">TOP AFFILIATE · {month}</p><h3>Leaderboard bulanan</h3>
          <p className="muted" data-testid="leaderboard-my-rank">{data?.me ? `Peringkat Anda: #${data.me.rank} · ${idr(data.me.total)}` : "Anda belum masuk peringkat bulan ini."}</p></div>
        <select className="lb-select" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="leaderboard-month-select">{months().map((m) => <option key={m}>{m}</option>)}</select>
      </div>
      {error && <div className="error" data-testid="leaderboard-error">Leaderboard gagal dimuat. Coba lagi nanti.</div>}
      {!data ? !error && <p className="muted pad-y">Memuat…</p> : !data.top.length ? <Empty testId="leaderboard-empty" icon={Trophy} title="Belum ada peringkat" text="Peringkat dihitung dari komisi sewa EA yang disetujui bulan ini." /> : (
        <>
          <div className="lb-row table-head"><span>#</span><span>AFFILIATE</span><span>SEWA EA</span><span>KOMISI</span></div>
          {[...data.top, ...(meOutside ? [data.me] : [])].map((r) => (
            <div className={r.is_me ? "lb-row me" : "lb-row"} key={r.rank} data-testid={`leaderboard-row-${r.rank}`}>
              <span className={`lb-rank r${r.rank}`}>{r.rank <= 3 ? <Trophy size={15} /> : null} {r.rank}</span>
              <span className="lb-name"><Avatar avatarId={r.avatar_id} name={r.name} className="lb-avatar" />{r.name}{r.is_me && " (Anda)"}</span><span>{r.rentals} sewa · {r.members} member</span><span className="up">{idr(r.total)}</span>
            </div>
          ))}
        </>
      )}
    </section>
  );
};
